/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const annonceRelanceResponseSchema = z.object({
      "produit": z.string().describe("Produit de diffusion de l'annonce relancée").optional(),
  "success": z.boolean().describe("Indique si la relance de l'annonce a réussi").optional(),
  "message": z.string().describe("Message détaillant le résultat de la relance de l'annonce").optional()
      })